import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const SearchOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7 10.2c0-2.99-2.44-5.43-5.43-5.43-2.99 0-5.43 2.44-5.43 5.43 0 2.99 2.44 5.43 5.43 5.43 2.99 0 5.43-2.44 5.43-5.43Zm-12.66 0c0-3.99 3.24-7.23 7.23-7.23s7.23 3.24 7.23 7.23-3.24 7.23-7.23 7.23-7.23-3.24-7.23-7.23Zm14.078 5.615a.9.9 0 0 0-1.275 1.27l3.06 3.07a.9.9 0 0 0 1.274-1.27l-3.06-3.07Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default SearchOutlined
